module.exports = __webpack_public_path__ + "static/media/Digital_marketing.76dd335d.jpg";